/**
 * Created by zhaoy on 19:45.
 * 远程开关界面
 */
import React from 'react';
import {Icon, Divider} from "antd";
import "../recharge/RechargeDetai.css"
import {fetchGet} from "../../utils/fetchRequest";
import {API} from "../../configs/api.config";
import  {Toast } from "antd-mobile";

class ElectronicCardOnOff extends React.Component{
    constructor(props){
        super(props);

        this.state={
            name:'RechargeDetail',
            IMEI:this.props.match.params.IMEI,
            data:{

            }
        };
    }


    componentDidMount(){
        document.title = '远程开关'

    }

    render(){
        const {IMEI } = this.state;
        return <div className="padding_15">
                <div onClick={()=>{
                                                 this.props.history.push('/electronicCardOn/'+IMEI);
                                             }}>
                                        <div className="flex_row padding_10  bg_white">
                                             <div className="flex_column">
                                                 <div className="span_14  text_bold">远程关机</div>
                                             </div>
                                             <div  className="flex_center_vertical_end item_flex">
                                                 {/*<div className="span_14 color_lightGreen">1111</div>*/}
                                                 <Icon type="right" />
                                             </div>
                                         </div>
                <div className="notify-item-line"></div>
                </div>
                <div onClick={()=>{
                                                 this.props.history.push('/electronicCardOff/'+IMEI);
                                             }}>
                                        <div className="flex_row padding_10  bg_white">
                                             <div className="flex_column">
                                                 <div className="span_14  text_bold">远程重启</div>
                                             </div>
                                             <div  className="flex_center_vertical_end item_flex">
                                                 <Icon type="right" />
                                             </div>
                                         </div>
                <div className="notify-item-line"></div>
                </div>
        </div>
    }
}

export  default ElectronicCardOnOff;